import type { ExtendedUserResponseSchema } from '@/types/user.types';
import type { PasswordChallengeResponse } from '@/types/auth.types';
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
interface Session {
  status: 'SUCCESS' | 'FAILED';
  time: number;
}

interface UserStore {
  user: (PasswordChallengeResponse & ExtendedUserResponseSchema) | null;
  setUser: (user: (PasswordChallengeResponse & ExtendedUserResponseSchema) | null) => void;
  accessToken: string | null;
  setAccessToken: (accessToken: string | null) => void;
  refreshToken: string | null;
  setRefreshToken: (refreshToken: string | null) => void;
  loginSessionToken: string | null;
  setLoginSessionToken: (loginSessionToken: string | null) => void;
  resetPasswordToken: string | undefined | null;
  setResetPasswordToken: (resetPasswordToken: string | undefined | null) => void;
  validateSession: Session | null;
  setValidateSession: (session: Session | null) => void;
  InactivityTimeout: boolean;
  setInactivityTimeout: (InactivityTimeout: boolean) => void;
  reset: () => void;
}

export const useUserStore = create<UserStore>()(
  persist(
    (set) => ({
      user: null,
      setUser: (user) => set({ user }),
      accessToken: null,
      setAccessToken: (accessToken) => set({ accessToken }),
      refreshToken: null,
      setRefreshToken: (refreshToken) => set({ refreshToken }),
      loginSessionToken: null,
      setLoginSessionToken: (loginSessionToken) => set({ loginSessionToken }),
      resetPasswordToken: null,
      setResetPasswordToken: (resetPasswordToken) => set({ resetPasswordToken }),
      validateSession: null,
      setValidateSession: (validateSession) => set({ validateSession }),
      InactivityTimeout: false,
      setInactivityTimeout: (InactivityTimeout) => set({ InactivityTimeout }),
      reset: () =>
        set({
          user: null,
          accessToken: null,
          refreshToken: null,
          loginSessionToken: null,
          resetPasswordToken: null,
          validateSession: null,
        }),
    }),
    {
      name: 'user',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
